import * as React from 'react';
import {generatePath} from 'react-router-dom';
// @ts-expect-error
import type {ContextRouter} from 'react-router-dom';

import type {FilterObject} from 'nutshell-core/types';

import type {ReportURLParams} from '../../reports/report-types';

import {VisitorsPage} from './visitors-page';

export type VisitorsPageTab = 'summary' | 'list' | 'settings';

type Props = ContextRouter & {
    activeFilters: FilterObject[];
    onParamChange: (arg1: any, arg2: boolean) => any;
    onParamPush: (arg1: any, arg2: boolean) => any;
    urlParams: ReportURLParams<'contacts'>;
    onRemoveAllFilters: () => void;
};

export function VisitorsPageWrapper(props: Props) {
    const getPathForTab = (newTab: VisitorsPageTab): string => {
        return generatePath(props.match.path, {
            tab: newTab,
        });
    };

    const getActiveTab = (): VisitorsPageTab => {
        return getTab(props.match.params.tab);
    };

    const onChangeTab = (newTab: VisitorsPageTab) => {
        props.history.push({
            pathname: getPathForTab(newTab),
            search: props.history.location.search,
        });
    };

    return (
        <VisitorsPage
            {...props}
            getPathForTab={getPathForTab}
            activeTab={getActiveTab()}
            onChangeTab={onChangeTab}
        />
    );
}

export const getTab = (tab?: string | null): VisitorsPageTab => {
    switch (tab) {
        case 'list':
            return 'list';
        case 'settings':
            return 'settings';
        case 'summary':
        default:
            return 'summary';
    }
};
